var legalContextPattern = /\b(?:termos?|privacidade|pol[ií]tica|consentimento|lgpd|dados pessoais|prote[cç][aã]o de dados|tratamento de dados|condi[cç][oõ]es|contract|terms?|privacy|policy|consent|data protection)\b/i;
var consentPattern = /\b(?:aceit(?:a|o|ar|e|ação)?|concord(?:a|o|ar|ância)?|autoriz(?:a|o|ar|ação)?|consent(?:imento|ir)?|agree(?:ment)?|accept(?:ance|ed)?|authorize(?:d)?)\b/i;
var requiredValidatorPattern = /^(?:required|isrequired|mandatory|notnull|notblank|notempty)$/i;
var toText = function (value) {
    if (typeof value === 'string' || typeof value === 'number') {
        return String(value);
    }
    return '';
};
var normalizeText = function (value) {
    return toText(value)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;|&#160;/gi, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
        .toLowerCase();
};
var isRecord = function (value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
var booleanValue = function (value) {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return value !== 0;
    }
    var normalizedValue = normalizeText(value).trim();
    if (['true', '1', 'yes', 'y', 'sim', 'required', 'mandatory'].indexOf(normalizedValue) >= 0) {
        return true;
    }
    if (['false', '0', 'no', 'n', 'nao', 'não', 'optional', ''].indexOf(normalizedValue) >= 0) {
        return false;
    }
    return undefined;
};
var isRequiredValidatorName = function (value) {
    return requiredValidatorPattern.test(normalizeText(value).replace(/\s+/g, ''));
};
var hasRequiredValidator = function (validators) {
    if (isRequiredValidatorName(validators)) {
        return true;
    }
    if (Array.isArray(validators)) {
        return validators.some(hasRequiredValidator);
    }
    if (!isRecord(validators)) {
        return false;
    }
    return Object.keys(validators).some(function (key) {
        var value = validators[key];
        var normalizedKey = normalizeText(key).replace(/\s+/g, '');
        if (isRequiredValidatorName(normalizedKey)) {
            return booleanValue(value) !== false;
        }
        if (['name', 'type', 'rule', 'validator', 'validation'].indexOf(normalizedKey) >= 0) {
            return isRequiredValidatorName(value);
        }
        if (['validators', 'validations', 'rules'].indexOf(normalizedKey) >= 0) {
            return hasRequiredValidator(value);
        }
        return false;
    });
};
var fieldSignalText = function (field) {
    var metadata = field;
    return [
        field.field,
        field.label,
        field.placeholder,
        metadata.alias,
        metadata.fieldAlias,
        metadata.name,
        metadata.description,
    ]
        .map(normalizeText)
        .join(' ');
};
var stepSignalText = function (formStep) {
    var metadata = formStep;
    return [
        formStep.stepName,
        formStep.formTitle,
        formStep.formSubtitle,
        formStep.formText,
        metadata.alias,
        metadata.name,
        metadata.description,
    ]
        .map(normalizeText)
        .join(' ');
};
var hasLegalSignal = function (value) { return legalContextPattern.test(value); };
var hasConsentSignal = function (value) { return consentPattern.test(value); };
var hasConsentCheckboxSignal = function (value) { return hasConsentSignal(value) || hasLegalSignal(value); };
var isRequiredCheckbox = function (field) {
    var metadata = field;
    return (booleanValue(field.required) === true ||
        booleanValue(metadata.isRequired) === true ||
        booleanValue(metadata.optional) === false ||
        hasRequiredValidator(metadata.validators) ||
        hasRequiredValidator(metadata.validator) ||
        hasRequiredValidator(metadata.validation) ||
        hasRequiredValidator(metadata.validations));
};
/**
 * Keeps the redesign scoped to legal consent. A legal READ paired with a
 * visible consent or required checkbox remains a terms step even when its
 * value is empty. Opaque READ/checkbox payloads without legal or consent
 * markers stay in the generic renderer.
 */
export var isTermsConsentStep = function (formStep) {
    var visibleReadFields = formStep.fields.filter(function (field) { return field.visible && field.type === 'READ'; });
    var visibleCheckboxFields = formStep.fields.filter(function (field) { return field.visible && field.type === 'CHECKBOX'; });
    if (visibleReadFields.length === 0 || visibleCheckboxFields.length === 0) {
        return false;
    }
    var hasLegalContext = hasLegalSignal(stepSignalText(formStep)) ||
        visibleReadFields.some(function (field) { return hasLegalSignal("".concat(fieldSignalText(field), " ").concat(normalizeText(field.value))); }) ||
        visibleCheckboxFields.some(function (field) { return hasLegalSignal(fieldSignalText(field)); });
    if (!hasLegalContext) {
        return false;
    }
    return visibleCheckboxFields.some(function (field) { return hasConsentCheckboxSignal(fieldSignalText(field)) || isRequiredCheckbox(field); });
};
